module.exports = __webpack_public_path__ + "img/podkrovni_pokoj_2.c1bf5aa3.jpg";